import * as angular from 'angular';

class NetworkPointBundleCreateCommentsCtrl implements ng.IController {
    constructor(private $location: ng.ILocationService) {}

    $onInit() {
        if (this.$location.search().scrollIntoView === 'comments') {
            const header = document.querySelector('[data-comments-header]');
            if (header) {
                setTimeout(() => {
                    console.log('scrolling now');
                    header.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                });
            }
        }
    }

    public bundleRequest: BundleChangeRequestDto;
    public readonly: boolean;
    public charLimit: number = 2000;
}

angular.module('app').component('pkpNetworkPointBundleCreateComments', {
    controller: NetworkPointBundleCreateCommentsCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-comments.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        bundleRequest: '=',
        commentHistory: '<'
    }
});
